var React = require('react');

function Play (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"50","cy":"50","r":"48","fill":"white","stroke":"black","strokeWidth":"4","key":0}),React.createElement("path",{"d":"M41.5 31.261L67.516 49.5L41.5 67.739L41.5 31.261Z","stroke":"black","strokeWidth":"4","key":1})]);
}

Play.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = Play;

Play.default = Play;
